/**
 * BrandMark – official GMB Graniti s.r.l. icon (octagonal frame with quarry
 * scene). Source 944×1132 px, white-on-black. mix-blend-mode: screen drops the
 * black background on the site's dark surfaces.
 */
const ICON_URL =
  "https://customer-assets.emergentagent.com/job_cervo-stone-hub/artifacts/23r8s1vt_IMG_6711.jpeg";

const ICON_ASPECT = 944 / 1132; // ~0.834 (slightly taller than wide)

export default function BrandMark({ height = 56, className = "", ...rest }) {
  return (
    <img
      src={ICON_URL}
      alt="GMB Graniti — Cava di Sienite"
      className={className}
      style={{
        mixBlendMode: "screen",
        display: "block",
        pointerEvents: "none",
        height,
        width: height * ICON_ASPECT,
      }}
      draggable={false}
      {...rest}
    />
  );
}
